<template>
    <div class="w-full h-full px-2 md:px-4 lg:px-8 py-4">
        <h1 class="text-gray-700 dark:text-gray-100 text-center lg:text-left text-2xl tracking-widest uppercase">Cadastrar nova loja</h1>
        <form class="flex flex-row flex-wrap mx-auto w-full md:w-10/12 lg:w-1/2 my-8 gap-y-4 gap-x-2" @submit.prevent="createLoja()">
            <p class="w-full font-bold text-gray-600 dark:text-gray-200">Dados Jurídicos</p>
            <span class="w-1/2">
                <Input label="CNPJ" type="text" v-model="cnpj" v-maska="'##.###.###/####-##'" :validation="v$.cnpj"/>
            </span>
            <span class="flex-1">
                <Select label="Faturamento" desc="descricao" type="text" v-model="faturamento_id" :list="listFaturamentos" :validation="v$.faturamento_id"/>
            </span>
            <Input label="Razão Social" type="text" v-model="razao" :validation="v$.razao"/>
            <Input label="Nome Fantasia" type="text" v-model="nome" :validation="v$.nome"/>

            <p class="w-full font-bold text-gray-600 dark:text-gray-200">Características</p>
            <span class="w-1/3">
                <Select label="Segmento" placeholder="Selecione um segmento" desc="descricao" type="text" v-model="segmento_id" :list="listSegmentos" :validation="v$.segmento_id"/>
            </span>

            <p class="w-full font-bold text-gray-600 dark:text-gray-200">Contatos</p>
            <Input label="Email" type="text" v-model="email" :validation="v$.email"/>
            <span class="w-1/3">
                <Input label="Telefone 1" type="text" v-model="telefone1" v-maska="['(##) # ####-####', '(##) ####-####']" :validation="v$.telefone1"/>
            </span>
            <span class="w-1/3">
                <Input label="Telefone 2" type="text" v-model="telefone2" v-maska="['(##) # ####-####', '(##) ####-####']" :validation="v$.telefone2"/>
            </span>
            <span class="flex-1">
                <Input label="Nome do Contato" type="text" v-model="nome_contato" :validation="v$.nome_contato"/>
            </span>

            <p class="w-full font-bold text-gray-600 dark:text-gray-200">Endereço</p>
            <span class="w-full">
                <Input label="Endereço" type="text" v-model="endereco.endereco" :validation="v$.endereco.endereco"/>
            </span>
            <span class="w-10/12">
                <Input label="Complemento" type="text" v-model="endereco.complemento" :validation="v$.endereco.complemento"/>
            </span>
            <span class="flex-1">
                <Input label="Nº" type="text" v-model="endereco.numero" :validation="v$.endereco.numero"/>
            </span>
            <span class="w-full">
                <Input label="Bairro" type="text" v-model="endereco.bairro" :validation="v$.endereco.bairro"/>
            </span>
            <span class="flex-1">
                <Input label="Cidade" type="text" v-model="endereco.cidade" :validation="v$.endereco.cidade"/>
            </span>
            <span class="w-1/12">
                <Select label="UF" type="text" v-model="endereco.uf_id" :list="listUFS" desc="uf" :validation="v$.endereco.uf_id"/>
            </span>
            <span class="w-1/4">
                <Input label="CEP" type="text" v-model="endereco.cep" v-maska="'##.###-###'" :validation="v$.endereco.cep"/>
            </span>
            <button type="submit" class="btn w-full h-12 bg-indigo-600 text-gray-50 rounded-lg text-sm" :disabled="v$.$invalid">CRIAR</button>
        </form>
    </div>
</template>

<script>
import Input from '@/components/Design/Input'
import Select from '@/components/Design/Select'
import { GET_FATURAMENTOS, GET_SEGMENTOS, POST_ADESAO } from '../../mixins/api.js'
import { requiredOnly, nomeFantasia, phone, phone2, emailValidator, cnpjValidator, enderecoValidator, personNameNotRequired } from '@/mixins/validators.js'
import { reactive, ref } from 'vue'
import useVuelidate from '@vuelidate/core'
import { findId } from '../../mixins/findData.js'
import { displayNotification } from '../../mixins/notification.js'
export default {
    name: 'NovaLoja',
    components: {
        Input,
        Select
    },
    setup () {
        const cnpj = ref('')
        const razao = ref('')
        const nome = ref('')
        const nome_contato = ref('')
        const segmento_id = ref('')
        const faturamento_id = ref('')
        const telefone1 = ref('')
        const telefone2 = ref('')
        const email = ref('')
        const endereco = reactive({
            bairro: '',
            cep: '',
            cidade: '',
            complemento: '',
            endereco: '',
            numero: '',
            uf_id: ''
        })

        const rules = {
            cnpj: cnpjValidator(),
            razao: requiredOnly(),
            nome: nomeFantasia(),
            nome_contato: personNameNotRequired(),
            segmento_id: requiredOnly(),
            faturamento_id: requiredOnly(),
            telefone1: phone(),
            telefone2: phone2(),
            email: emailValidator(),
            endereco: enderecoValidator()
        }
        const v$ = useVuelidate(rules, { cnpj, razao, nome, nome_contato, segmento_id, faturamento_id, telefone1, telefone2, email, endereco })

        const createLoja = async () => {
            const body = {
                cnpj: cnpj.value.replaceAll('.', '').replace('/', '').replace('-', ''),
                razao_social: razao.value,
                nome_fantasia: nome.value,
                nome_contato: nome_contato.value,
                segmento_id: findId(listSegmentos.value, segmento_id.value, 'descricao'),
                faturamento_id: findId(listFaturamentos.value, faturamento_id.value, 'descricao'),
                telefone1: telefone1.value.replace('(', '').replace(')', '').replace('-', '').replace(' ', '').replace(' ', ''),
                telefone2: telefone2.value.replace('(', '').replace(')', '').replace('-', '').replace(' ', '').replace(' ', ''),
                email: email.value,
                bairro: endereco.bairro,
                cep: endereco.cep.replace('.', '').replace('-', ''),
                cidade: endereco.cidade,
                complemento: endereco.complemento,
                endereco: endereco.endereco,
                numero: endereco.numero,
                uf_id: endereco.uf_id

            }

            await POST_ADESAO(body).then(r => {
                displayNotification(r)
                cnpj.value = ''
                razao.value = ''
                nome.value = ''
                nome_contato.value = ''
                segmento_id.value = ''
                faturamento_id.value = ''
                telefone1.value = ''
                telefone2.value = ''
                email.value = ''
                Object.assign(endereco, {
                    bairro: '',
                    cep: '',
                    cidade: '',
                    complemento: '',
                    endereco: '',
                    numero: '',
                    uf_id: ''
                })
                v$.value.$reset()
            }).catch(e => {
                displayNotification(e.response)
            })
        }

        const listFaturamentos = ref([])
        const listSegmentos = ref([])
        const listUFS = ref([
            { id: '1', uf: 'AC', nome: 'Acre' },
            { id: '2', uf: 'AL', nome: 'Alagoas' },
            { id: '3', uf: 'AP', nome: 'Amapá' },
            { id: '4', uf: 'AM', nome: 'Amazonas' },
            { id: '5', uf: 'BA', nome: 'Bahia' },
            { id: '6', uf: 'CE', nome: 'Ceará' },
            { id: '7', uf: 'DF', nome: 'Distrito Federal' },
            { id: '8', uf: 'ES', nome: 'Espirito Santo' },
            { id: '9', uf: 'GO', nome: 'Goiás' },
            { id: '10', uf: 'MA', nome: 'Maranhão' },
            { id: '11', uf: 'MS', nome: 'Mato Grosso do Sul' },
            { id: '12', uf: 'MT', nome: 'Mato Grosso' },
            { id: '13', uf: 'MG', nome: 'Minas Gerais' },
            { id: '14', uf: 'PA', nome: 'Pará' },
            { id: '15', uf: 'PB', nome: 'Paraíba' },
            { id: '16', uf: 'PR', nome: 'Paraná' },
            { id: '17', uf: 'PE', nome: 'Pernambuco' },
            { id: '18', uf: 'PI', nome: 'Piauí' },
            { id: '19', uf: 'RJ', nome: 'Rio de Janeiro' },
            { id: '20', uf: 'RN', nome: 'Rio Grande do Norte' },
            { id: '21', uf: 'RS', nome: 'Rio Grande do Sul' },
            { id: '22', uf: 'RO', nome: 'Rondônia' },
            { id: '23', uf: 'RR', nome: 'Roraima' },
            { id: '24', uf: 'SC', nome: 'Santa Catarina' },
            { id: '25', uf: 'SP', nome: 'São Paulo' },
            { id: '26', uf: 'SE', nome: 'Sergipe' },
            { id: '27', uf: 'TO', nome: 'Tocantins' }
        ])
        const getLists = async () => {
            await GET_FATURAMENTOS().then(r => {
                listFaturamentos.value = r.data
            })
            await GET_SEGMENTOS().then(r => {
                listSegmentos.value = r.data
            })
        }
        getLists()
        return {
            cnpj,
            razao,
            nome,
            nome_contato,
            segmento_id,
            faturamento_id,
            telefone1,
            telefone2,
            email,
            endereco,

            listFaturamentos,
            listSegmentos,
            listUFS,

            v$,
            createLoja
        }
    }
}
</script>
<style>
</style>
